import useClearPageConfig from 'hooks/clearPageConfig';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { emitRouteChange } from '@kizenapps/engine/util';
import { maybeTrackGAPageView, trackKizenPageView } from 'utility/analytics';

export const PageView = ({ pageLoadTs, pageLoadId, enabled }) => {
  const location = useLocation();
  const { pathname } = location;
  const authentication = useSelector((s) => s.authentication);

  const userId = authentication?.teamMember?.id;
  const businessId = authentication?.chosenBusiness?.id;
  const showBlocker = authentication?.showBlocker;

  const component = useClearPageConfig();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    maybeTrackGAPageView(document?.title, window.location.href, pathname);
    if (userId && businessId && !showBlocker) {
      trackKizenPageView(pathname, pageLoadTs, pageLoadId);
    }
  }, [
    pathname,
    pageLoadId,
    pageLoadTs,
    userId,
    businessId,
    showBlocker,
    enabled,
  ]);

  useEffect(() => {
    emitRouteChange();
  }, [location]);

  return component;
};
